<template>
  <div class="list-tabs" role="tablist" :aria-label="i18n.tabs.selectView">
    <template v-if="currentDevice.isDesktop">
      <button
        v-for="tab in tabs"
        :id="`tab-${tab.key}`"
        :key="tab.key"
        class="list-tabs__item"
        :class="{ active: activeTab === tab.key }"
        role="tab"
        :aria-selected="activeTab === tab.key ? 'true' : 'false'"
        :aria-controls="`panel-${tab.key}-view`"
        :tabindex="activeTab === tab.key ? 0 : -1"
        @click="setActiveTab(tab.key)"
        @keydown="handleTabKeydown($event, tab.key)"
      >
        {{ tab.text }}
      </button>
    </template>
    <template v-if="currentDevice.isTablet || currentDevice.isMobile">
      <Modal modal-id="list-tabs" modal-class="list-tabs__modal full-page" :aria-config="ariaConfig">
        <template #trigger>
          <button type="button" aria-haspopup="dialog" aria-expanded="false" class="list-tabs__map">
            <span class="s s-pin mr-2"></span>
            {{ i18n.tabs.seeOnMap }}
          </button>
        </template>
        <template #header>
          <p class="list-tabs__modal-title">{{ i18n.tabs.chooseHotelOnMap }}</p>
        </template>
        <template #content>
          <HotelsMap />
        </template>
      </Modal>
    </template>
  </div>
</template>
<script setup>
import { storeToRefs } from 'pinia'
import { inject } from 'vue'

import { currentDevice } from '../../../../../core/utils/currentDevice'
import { useHotelsInfoStore } from '../../../blocks/HotelsInfo/store/hotels_info'
import { loadStyles } from '../../../mixins/LoadStyles/LoadStyles'
import Modal from '../../Modal/Modal'
import { emitUtagEvent } from '../HotelsInfo.analytics'
import HotelsMap from '../HotelsMap/HotelsMap'

/**
 * Styles
 */
const COMPONENT_NAME = 'ListTabs'
loadStyles({ name: COMPONENT_NAME, folder: 'components/HotelsInfo' })

/**
 * Store
 */
const hotelsInfoStore = useHotelsInfoStore()

const { activeTab } = storeToRefs(hotelsInfoStore)

/**
 * Inject
 */
const i18n = inject('i18n')

/**
 * Data
 */
const tabs = [
  {
    key: 'list',
    text: i18n.value.tabs.list,
  },
  {
    key: 'map',
    text: i18n.value.tabs.map,
  },
]
const ariaConfig = {
  close: i18n.value.modals.close,
}
/**
 * Methods
 */
function sendUtagEvents(tab) {
  emitUtagEvent({
    event_name: 'view_by',
    event_cat: 'destinations',
    event_act: 'view by',
    event_lbl: tab,
    event_purpose: 'inspiration',
    event_structure: 'body',
  })
}
function setActiveTab(tab) {
  hotelsInfoStore.setActiveTab(tab)
  sendUtagEvents(tab)
}
function handleTabKeydown(event, currentTabKey) {
  const tabsElements = Array.from(event.currentTarget.closest('[role="tablist"]').querySelectorAll('[role="tab"]'))
  const currentIndex = tabsElements.findIndex(tab => tab.id === `tab-${currentTabKey}`)

  let nextIndex = -1

  switch (event.key) {
    case 'ArrowRight':
      nextIndex = (currentIndex + 1) % tabsElements.length
      break
    case 'ArrowLeft':
      nextIndex = (currentIndex - 1 + tabsElements.length) % tabsElements.length
      break
    case 'Home':
      nextIndex = 0
      break
    case 'End':
      nextIndex = tabsElements.length - 1
      break
    default:
      return
  }

  if (nextIndex !== -1) {
    event.preventDefault()
    const nextTabElement = tabsElements[nextIndex]
    if (nextTabElement) {
      setActiveTab(tabs[nextIndex].key)
      nextTabElement.focus()
    }
  }
}
</script>
